import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { StyledScrollbars } from '../../lib/utils/mixins';

import { BreakPointToken } from '../../hooks/useMediaQuery';
import { keyframes } from '@emotion/react';

const {
	spacing: {
		size_4px: { height: size_4 },
		size_8px: { height: size_8 },
		size_12px: { height: size_12 },
		size_16px: { height: size_16 },
		size_160px: { height: size_160 }
	},
	color: colours
} = tokens;

const spinner = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(359deg);
	}
`;

export const TypeaheadResultsList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	max-height: 25vh;
	margin: 0 ${size_16}px 0 0;
	overflow: auto;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		width: 375px;
		max-height: none;
		margin: 0;
	}

	${StyledScrollbars}
`;

export const TypeaheadResult = styled.li`
	cursor: pointer;
	padding: 0;
`;

export const TypeaheadResultButton = styled.button`
	border: none;
	background: none;
	display: grid;
	grid-template-columns: min-content 1fr;
	gap: ${size_8}px;
	width: 100%;
	cursor: pointer;
	text-align: left;
	padding: ${size_8}px ${size_16}px;
	background: ${colours.light.background_primary};
	transition: background-color 0.3s ease-in-out;
	z-index: 0;
	color: ${colours.light.text_primary};

	&:hover,
	&:focus,
	&:active {
		background: ${colours.light.background_secondary};
		z-index: 1;
	}
`;

export const TypeaheadResultLabel = styled.label`
	align-self: center;
`;

export const TypeaheadMobileInput = styled.div`
	margin: ${-1 * size_4}px 0 ${size_12}px;
	padding: 0 ${size_16}px;
`;

export const TypeaheadRecentTitle = styled.div`
	padding: 0 ${size_16}px;
	margin: ${size_4}px 0 ${size_8}px;
`;

export const TypeaheadSearching = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: ${size_16}px;

	[data-search] {
		animation: ${spinner} 1s linear infinite;
		margin-inline-end: ${size_8}px;
	}

	p {
		@media (min-width: ${BreakPointToken.MdMin}px) {
			min-width: ${size_160 + size_160}px;
		}
	}
`;
